<template>
	<div class="promos-rules-indicator" v-if="type == 'big'">
		<div
			:class="{
				'promos-rules-indicator__item': 1,
				success: rule.isValid,
				failure: !rule.isValid,
			}"
			v-for="rule in validatedRules"
			:key="rule.rule"
		>
			<svg
				v-if="rule.isValid"
				class="promos-rules-indicator__item__icon"
				width="12"
				height="10"
				viewBox="0 0 12 10"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M12 1.42L10.59 0L4 6.59L1.42 4.02L0 5.43L4 9.42L12 1.42Z"
					fill="var(--green)"
				/>
			</svg>
			<svg
				v-else
				class="promos-rules-indicator__item__icon"
				width="12"
				viewBox="0 0 18 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M3.01164 15.0306H14.9975C16.3158 15.0306 17.1433 13.6056 16.4883 12.4606L10.5 1.98979C9.84081 0.837292 8.17914 0.836458 7.51914 1.98896L1.52081 12.4598C0.865808 13.6048 1.69247 15.0306 3.01164 15.0306Z"
					stroke="var(--yellow)"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M9.00205 9.17904V6.5957"
					stroke="var(--yellow)"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M8.99581 11.7499H9.00415"
					stroke="var(--yellow)"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>

			<span class="promos-rules-indicator__item__value"
				>{{
					rule.rule
						.replace("opt-in-", "")
						.replace("opt-", "")
						.replace("min-", "")
						.replace("max-", "")
						.split("-")
						.join(" ")
						.toLowerCase()
				}}
				&middot; {{ rule.value }}
			</span>
		</div>
	</div>
	<div class="promos-rules-indicator-small" v-else>
		<svg
			v-if="isFullyValid"
			width="12"
			height="10"
			viewBox="0 0 12 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 1.42L10.59 0L4 6.59L1.42 4.02L0 5.43L4 9.42L12 1.42Z"
				fill="var(--green)"
			/>
		</svg>
		<svg
			v-else
			width="12"
			viewBox="0 0 18 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M3.01164 15.0306H14.9975C16.3158 15.0306 17.1433 13.6056 16.4883 12.4606L10.5 1.98979C9.84081 0.837292 8.17914 0.836458 7.51914 1.98896L1.52081 12.4598C0.865808 13.6048 1.69247 15.0306 3.01164 15.0306Z"
				stroke="var(--yellow)"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M9.00205 9.17904V6.5957"
				stroke="var(--yellow)"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M8.99581 11.7499H9.00415"
				stroke="var(--yellow)"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	props: {
		rules: {
			type: Array,
			required: true,
			default: () => [],
		},
		type: {
			type: String,
			required: false,
			default: "big",
		},
	},
	computed: {
		isFullyValid() {
			return this.validatedRules
				.map((rule) => rule.isValid)
				.reduce((a, b) => {
					return a && b;
				}, 1);
		},
		validatedRules() {
			return this.rules.map((rule) => {
				rule.isValid = false;
				if (
					rule.rule == "opt-in-min-bet-amount" &&
					this.betAmount >= Number(rule.value)
				)
					rule.isValid = true;
				if (
					rule.rule == "opt-in-min-odds" &&
					this.totalOdds >= Number(rule.value)
				)
					rule.isValid = true;
				if (
					rule.rule == "opt-min-betslips" &&
					this.totalBetslips >= Number(rule.value)
				)
					rule.isValid = true;
				return rule;
			});
		},
		totalOdds() {
			let oddValues = this.$store.getters.betSlip
				.filter((bet) => Number(bet.odd.odd_value) > 0)
				.map((bet) => Number(bet.odd.odd_value));

			return Math.trunc(oddValues.reduce((a, b) => a * b, 1) * 100) / 100;
		},
		totalBetslips() {
			return this.$store.getters.betSlipCount;
		},
		betAmount() {
			return this.$store.getters.stake;
		},
	},
};
</script>

<style lang="scss">
.promos-rules-indicator {
	display: flex;
	flex-direction: row;
	align-items: center;

	&__item {
		margin-right: 5px;
		font-weight: var(--font-weight-medium);
		font-style: normal;
		text-align: center;
		padding: 3px 5px;
		border-radius: 4px;
		font-size: var(--font-smallest);
		display: flex;
		flex-direction: row;
		align-items: center;
		&.success {
			color: var(--green);
			background-color: var(--light-green);
		}
		&.failure {
			color: var(--yellow);
			background-color: var(--light-yellow);
		}
		&__icon {
			width: 10px;
			margin-right: 5px;
		}
		&__value {
		}
	}
}
.promos-rules-indicator-small {
	display: inline-block;
}
</style>
